import React, { Component } from "react";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";

class TermsAndConditionsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      type: null,
      dueDate: null,
      content: null
    };
  }

  componentWillMount() {}

  componentDidUpdate(prevProps) {
    const props = ["name", "type", "dueDate", "content"];
    props.forEach(prop => {
      if (this.props.values[prop] !== prevProps.values[prop]) {
        this.setState({
          [prop]: getValue(this.props.values, prop)
        });
      }
    });
  }

  render() {
    return (
      <Row gutter={10}>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"termsandconditions"}
            attribute={"name"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "name")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"termsandconditions"}
            attribute={"type"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "type")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"termsandconditions"}
            attribute={"dueDate"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "dueDate")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"termsandconditions"}
            attribute={"version"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "version")}
          />
        </Col>
        <Col span={24}>
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"termsandconditions"}
            attribute={"content"}
            id={this.props.id}
            autoSave
            value={getValue(this.props.values, "content")}
          />
        </Col>
      </Row>
    );
  }
}

export default withValues(TermsAndConditionsEdit);



// WEBPACK FOOTER //
// ./src/forms/TermsAndConditionsEdit.js